import MetricBase from "models/metrics/MetricBase";
import i18n from "i18next";
import EmptyUnit from "models/metrics/unit/EmptyUnit";
import ConnectivityGroup from "../../../../groups/ConnectivityGroup";

class MetricNotAvailableRate extends MetricBase {
    constructor() {
        super({
            field: "metric_not_available_rate",
            defaultVisibility: false,
            unit: new EmptyUnit(),
            chartName: i18n.t("metrics.tripadvisor.not_available_rate.chartName"),
            serieLabel: i18n.t("metrics.tripadvisor.not_available_rate.serieLabel"),
            tooltip: i18n.t("metrics.tripadvisor.not_available_rate.tooltip"),
            group: new ConnectivityGroup(),
        });
    }
}

export default MetricNotAvailableRate;